import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators';

import '@carbon/web-components/es/components/tile/tile.js';
import '@carbon/web-components/es/components/progress-indicator';
import '@carbon/web-components/es/components/code-snippet/code-snippet.js';

import { PROGRESS_STEP_STAT } from '@carbon/web-components/es/components/progress-indicator/progress-step';

import { grow, margin, marginLeft, marginRight, row } from '../styles';


import './PDQCodeHtml'
import './PDQTutorialWelcome'
import './PDQTutorialTheory'
import './PDQTutorialJson'
import './PDQTutorialPerspectiveViewer'
import './PDQTutorialConfigOverlay'
import './PDQTutorialRemoteData'
import './PDQTutorialTransformData'
import './PDQTutorialSelection'
import './PDQTutorialLiquid'
// import './PDQTutorialView'
import './PDQTutorialLiquidScripts'
import './PDQTutorialLiquidSlicer'
import './PDQTutorialUsingModelFromCode'
import './PDQTutorialSchemaForms'
import './PDQTutorialPDFViewer'
import './PDQTutorialGoogleAuth'


@customElement('pdq-tutorial-wrapper')
export class PDQTutorialWrapper extends LitElement {
  static styles = [
    row, grow, margin, marginLeft, marginRight,
    css`
      :host {
        display: block;
        padding: 16px;
        margin: 16px auto;
      }
  `];

  @property({type: Array})
  steps = [
    {title: 'pdq-flow', subTitle: 'Welcome...', component: html`<pdq-tutorial-welcome></pdq-tutorial-welcome>`},
    {title: 'Theory', subTitle: 'why pdq-flow', component: html`<pdq-tutorial-theory></pdq-tutorial-theory>`},
    {title: 'Static Data', subTitle: 'Example: adding static data', component: html`<pdq-tutorial-json></pdq-tutorial-json>`},
    {title: 'Viewing Data', subTitle: 'Example: adding a data grid', component: html`<pdq-tutorial-perspective-viewer></pdq-tutorial-perspective-viewer>`},
    {title: 'Config Overlay', subTitle: 'How to: visualize config', component: html`<pdq-tutorial-config-overlay></pdq-tutorial-config-overlay>`},
    {title: 'Remote Data', subTitle: 'Example: remote json data', component: html`<pdq-tutorial-remote-data></pdq-tutorial-remote-data>`},
    {title: 'Transform Data', subTitle: 'Example: transform json data', component: html`<pdq-tutorial-transform-data></pdq-tutorial-transform-data>`},
    {title: 'Selection', subTitle: 'Example: master detail', component: html`<pdq-tutorial-selection></pdq-tutorial-selection>`},
    {title: 'Templating', subTitle: 'Example: liquid templates', component: html`<pdq-tutorial-liquid></pdq-tutorial-liquid>`},
//    {title: 'Views', subTitle: 'Example: views', component: html`<pdq-tutorial-view></pdq-tutorial-view>`},
    {title: 'Liquid Events', subTitle: 'Example: templating and events', component: html`<pdq-tutorial-liquid-scripts></pdq-tutorial-liquid-scripts>`},
    {title: 'Liquid Slicer', subTitle: 'Example: creating a slicer', component: html`<pdq-tutorial-liquid-slicer></pdq-tutorial-liquid-slicer>`},
    {title: 'From code', subTitle: 'Example: direct model access', component: html`<pdq-tutorial-using-model-from-code></pdq-tutorial-using-model-from-code>`},
    {title: 'Schema Forms', subTitle: 'Example: JSON Schema forms', component: html`<pdq-tutorial-schema-forms></pdq-tutorial-schema-forms>`},
    {title: 'PDF Viewer', subTitle: 'Example: PDF Viewer', component: html`<pdq-tutorial-pdf-viewer></pdq-tutorial-pdf-viewer>`},
    {title: 'Google Auth', subTitle: 'Example: Google Auth', component: html`<pdq-tutorial-google-auth></pdq-tutorial-google-auth>`},
  ];

  _currentStep=0;

  @property({type: Number})
  get currentStep() {
    return this._currentStep;
  }
  set currentStep(value: number){
    this._currentStep = value;
    this.unlockedStep = Math.max(this.unlockedStep, this._currentStep)
    this.setStep()
  }
  unlockedStep = 0

  constructor() {
    super();
    if (window.location.hash) {
      const step = parseInt(window.location.hash.substring(1));
      if (step)
        this.currentStep = step;
    }
  }

  private renderStepContent() {
    return this.steps[this.currentStep].component;
  }

  protected render() {

    return html`
      <div class="row">
      <cds-progress-indicator>
        <style>
          cds-progress-indicator {
            flex-direction: column;
          }
          cds-progress-step {
            min-height: 70px;
            inline-size: 12rem;
            min-inline-size: 8rem;
          }
          .cds--progress-label{
            max-inline-size: 12rem!important;
          }
      </style>
        ${this.steps.map((step, index) => html`
          <cds-progress-step
            label="${step.title}"
            secondary-label="${step.subTitle}"
            state="${this.state(index)}"
            ?disabled="${index > this.unlockedStep}"
            @click="${() => this.currentStep = index}"
          >
          </cds-progress-step>
        `)}
      </cds-progress-indicator>
        <div class="col grow" style="min-height: 90vh">
          <div class="row ml-2 mr-2">
            <cds-button size="sm" @click="${this.prevStep}" ?disabled="${this.currentStep === 0}">Previous</cds-button>
            <div class="grow"></div>
            <cds-button size="sm" @click="${this.nextStep}" ?disabled="${this.currentStep === this.steps.length -1}">Next</cds-button>
          </div>
          <div style="min-height: 90vh">
            ${this.renderStepContent()}
          </div>
          <div class="row ml-2 mr-2">
            <cds-button size="sm" @click="${this.prevStep}" ?disabled="${this.currentStep === 0}">Previous</cds-button>
            <div class="grow"></div>
            <cds-button size="sm" @click="${this.nextStep}" ?disabled="${this.currentStep === this.steps.length -1}">Next</cds-button>
          </div>
        </div>
      </div>
    `;
  }

  updated(){
    setTimeout(() => {

      this.shadowRoot?.querySelectorAll('cds-progress-step')?.forEach((step, idx) => {
        //console.log(step);
        const style = step.shadowRoot?.querySelector('span.cds--progress-line')?.style;
        if (!style)
          return;
        style.display = 'block';
        style.position = 'absolute';
        style.left = '-8px';
        style.top = '0';
        style.bottom = '0';
        style.width = '2px';
        style.height =  '100%';
      });
    }, 20)
  }

  state(idx: number){
    if (idx < this.currentStep) {
      return PROGRESS_STEP_STAT.COMPLETE;
    }
    if (idx === this.currentStep) {
      return PROGRESS_STEP_STAT.CURRENT;
    }
    return PROGRESS_STEP_STAT.INCOMPLETE;
  }

  nextStep() {
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
    }
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  setStep(){
    this.pushHistory()
    this.requestUpdate();
  }

  pushHistory(){
    history.pushState({step: this.currentStep}, `PDQ Tutorial - Step: ${this.currentStep}`, `#${this.currentStep}`)
  }
}

